import Vue from "vue";
import Router from "vue-router";

import store from './store'
import axios from 'axios'
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import Components from "./views/Components.vue";
import PhoneSignup from "./views/PhoneSignup.vue";
import Account from "./views/Account.vue";
import Portfolio from "./views/Portfolio.vue";
import MarketSegment from "./views/Marketsegments.vue";
import Landing from "./views/Landing.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import Profile from "./views/Profile.vue";

Vue.use(Router);

const router = new Router({
    linkExactActiveClass: "active",
    routes: [{
            path: "/account",
            name: "account",
            meta: { requiresSignupType: true },
            components: {
                header: AppHeader,
                default: Account,
                // footer: AppFooter
            }
        },
        {
            path: "/portfolio",
            name: "portfolio",
            meta: { requiresAuth: true },
            components: {
                header: AppHeader,
                default: Portfolio,
                // footer: AppFooter
            }
        },
        {
            path: "/marketsegs",
            name: "marketsegs",
            meta: { requiresAuth: true },
            components: {
                header: AppHeader,
                default: MarketSegment,
                // footer: AppFooter
            }
        },
        {
            path: "/landing",
            name: "landing",
            meta: { requiresAuth: true },
            components: {
                header: AppHeader,
                default: Landing,
                footer: AppFooter
            }
        },
        {
            path: "/profile",
            name: "profile",
            meta: { requiresAuth: true },
            components: {
                header: AppHeader,
                default: Profile,
                footer: AppFooter
            }
        },
        {
            path: "/login",
            name: "login",
            components: {
                header: AppHeader,
                default: Login,
                // footer: AppFooter
            }
        },
        {
            path: "/",
            name: "register",
            components: {
                header: AppHeader,
                default: Register,
            }
        },
        {
            path: "/phonesignup",
            name: "phonesignup",
            components: {
                // header: AppHeader,
                default: PhoneSignup,
                // footer: AppFooter
            }
        },
    ],
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    }
})


router.beforeEach((to, from, next) => {
    // Insert authentication token to axios request
    // if (store.state.token) {
    //     var authHeader = 'Bearer ' + store.state.token
    //     axios.defaults.headers.common['Authorization'] = authHeader
    // } else {
    //     delete axios.defaults.headers.common['Authorization']
    // }

    // Check if this route requires auth
    if (to.matched.some(record => record.meta.requiresSignupType)) {
        if (store.state.signup_type) {
            next()
        } else {
            router.push({ name: 'register' })
        }
    } else {
        next()
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.state.token) {
            next()
        } else {
            router.push({ name: 'register' })
        }
    } else {
        next()
    }
})

export default router